// extracted by mini-css-extract-plugin
export default {"container":"styles_container__hPhgx","deck":"styles_deck__l-q5x"};